<template>
  <div class="sp-tab-panel" :class="classModifiers">
    <slot />
  </div>
</template>

<script setup>
import { computed } from "vue";

import { booleanAttribute, toBoolean } from "#ce/utils/props";

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  active: booleanAttribute(),
});

const isActive = computed(() => toBoolean(props.active));

const classModifiers = computed(() => ({
  "--is-active": isActive.value,
}));
</script>

<style scoped lang="scss">
.sp-tab-panel {
  display: none;

  &.--is-active {
    display: block;
  }
}
</style>
